"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var settings_service_1 = require("./settings.service");
var close_reason_model_1 = require("../models/close-reason.model");
var logging_service_1 = require("./logging.service");
var log_event_model_1 = require("../models/log-event.model");
var options_service_1 = require("./options.service");
var InvitationService = /** @class */ (function () {
    function InvitationService(settingsService, loggingService, optionsService) {
        var _this = this;
        this.settingsService = settingsService;
        this.loggingService = loggingService;
        this.optionsService = optionsService;
        this.optionsService.options$.subscribe(function (o) {
            _this._hasInvitation = !!o.Invitation;
        });
    }
    InvitationService.prototype.acceptInvitation = function () {
        parent.postMessage('uwfAcceptInvitation', '*');
        console.log('Chat invitation has been accepted.');
        this.loggingService.logEvent(log_event_model_1.LOG_EVENTS.InvitationAccept);
    };
    InvitationService.prototype.hideInvitation = function (reason) {
        parent.postMessage('uwfHideInvitation', '*');
        console.log("Chat invitation has been hidden. Reason: " + close_reason_model_1.CloseReason[reason]);
        switch (reason) {
            case close_reason_model_1.CloseReason.Auto:
                this.loggingService.logEvent(log_event_model_1.LOG_EVENTS.InvitationTimeOut);
                break;
            case close_reason_model_1.CloseReason.ByUser:
                this.loggingService.logEvent(log_event_model_1.LOG_EVENTS.InvitationDecline);
                break;
        }
    };
    InvitationService.prototype.showInvitation = function () {
        if (!this._hasInvitation) {
            console.log('Invitation settings is not available.  Accepting invitation by default');
            this.acceptInvitation();
            return;
        }
        parent.postMessage('uwfShowInvitation', '*');
        console.log('Chat invitation has been shown.');
        this.loggingService.logEvent(log_event_model_1.LOG_EVENTS.InvitationOffer);
        this.settingsService.lastInvitationTimestamp = Date.now();
    };
    InvitationService.prototype.showProactivErrorView = function () {
        parent.postMessage('uwfShowInvitation', '*');
        console.log('Proactive Chat error view has been shown.');
    };
    return InvitationService;
}());
exports.InvitationService = InvitationService;
